var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"test","onbeforeunload":"return myFunction()"}},[_c('div',{on:{"click":_vm.alert}},[_vm._v(_vm._s(_vm.count))]),_c('h1',[_vm._v("haishikeyi")])])}
var staticRenderFns = []

export { render, staticRenderFns }